import {Result as AntdResult, type ResultProps} from 'antd'
import type React from 'react'
import {LoadedErrorIcon, NoContentIcon, NoDataIcon, NoMessageIcon, NoTaskIcon} from '../svg'

export type ResultIconType = 'noData' | 'noContent' | 'noMessage' | 'noTask' | 'loadedError'

const Result = (props: ResultProps & {iconTypes?: ResultIconType}) => {
  const custTomMap: {[key: string]: React.ReactNode} = {
    noTask: <NoTaskIcon />,
    noContent: <NoContentIcon />,
    noData: <NoDataIcon />,
    noMessage: <NoMessageIcon />,
    loadedError: <LoadedErrorIcon />,
  }

  const icon = props.iconTypes ? custTomMap[props.iconTypes] || null : undefined

  return <AntdResult {...{icon: icon, ...props}} />
}

export default Result
